import type { DeepRequired } from '../fixtures.types'

const generalInsuranceProduct: DeepRequired<CreateGeneralInsuranceProduct> = {
  __typename: 'CreateGeneralInsuranceProduct',
  general_insurance_product_id: 'TEST_ID',
  client_ids: [],
  case_ids: [],
  details: {
    __typename: 'CreateGeneralInsuranceProductDetails',
    quote_reference: null,
    status: null,
    premium_amount: null,
    provider_id: null,
    buildings_cover_level: null,
    contents_cover_level: null,
    underwriter: null,
    provider: null,
    type: null,
    term: null,
    annual_premium: null,
    end_date: null,
    premium_frequency: null,
    policy_number: null,
    commission: null,
    excess: null,
    buildings_excess_if_different: null,
    start_date: null,
    specified_rebuild_cost: null,
    rental_cover: null,
    includes_accidental_damage: null,
    accidental_damage_premium: null,
    includes_home_emergency_cover: null,
    home_emergency_premium: null,
    includes_legal_cover: null,
    legal_cover_premium: null,
    includes_personal_possessions_cover: null,
    personal_possessions_sum_assured: null,
    personal_possessions_premium: null,
    years_no_claims: null,
    buildings_years_no_claims_if_different: null,
    specified_items: null,
    external: [],
  },
  property_ids: [],
}

export default generalInsuranceProduct
